module.exports = "<router-outlet></router-outlet>\r\n<!-- <app-loader></app-loader> -->\r\n<ng4-loading-spinner> </ng4-loading-spinner>\r\n<simple-notifications [options]=\"notificationsOptions\" ></simple-notifications>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main